var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "envelope"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.875 0.40625H3.125C2.37211 0.410516 1.65126 0.711494 1.11888 1.24388C0.586494 1.77626 0.285516 2.49711 0.28125 3.25V22.75C0.285516 23.5029 0.586494 24.2237 1.11888 24.7561C1.65126 25.2885 2.37211 25.5895 3.125 25.5938H25.875C26.6279 25.5895 27.3487 25.2885 27.8811 24.7561C28.4135 24.2237 28.7145 23.5029 28.7188 22.75V3.25C28.7145 2.49711 28.4135 1.77626 27.8811 1.24388C27.3487 0.711494 26.6279 0.410516 25.875 0.40625ZM3.125 2.84375H25.875C25.9827 2.84375 26.0861 2.88655 26.1623 2.96274C26.2384 3.03892 26.2812 3.14226 26.2812 3.25V5.7525L14.5 11.635L2.71875 5.7525V3.25C2.71875 3.14226 2.76155 3.03892 2.83774 2.96274C2.91392 2.88655 3.01726 2.84375 3.125 2.84375ZM25.875 23.1562H3.125C3.01726 23.1562 2.91392 23.1134 2.83774 23.0373C2.76155 22.9611 2.71875 22.8577 2.71875 22.75V8.46625L13.9475 14.0887C14.119 14.1746 14.3082 14.2192 14.5 14.2192C14.6918 14.2192 14.881 14.1746 15.0525 14.0887L26.2812 8.46625V22.75C26.2812 22.8577 26.2384 22.9611 26.1623 23.0373C26.0861 23.1134 25.9827 23.1562 25.875 23.1562Z",
    fill: "#BCC3CD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon2);
export default __webpack_public_path__ + "static/media/cardIcon_2.ef9cfd6e153fb12a6d0a00f8f8a4d06c.svg";
export { ForwardRef as ReactComponent };